import React from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";

import ErrorBoundary from "components/ErrorBoundary";
import ScreenLocker from "components/ScreenLocker";
import UniversalModals from "components/UniversalModals";
import { useEffect } from "react";
import AppRoutes from "routes";
import packageJson from "../package.json";
import { getWebVersion } from "store/actions";
import semver from "semver";
import ChatBot from "components/chatBot";

// Provides theme for secondary color //
const theme = createTheme({
  palette: {
    secondary: {
      main: "#f50057",
    },
    primary: {
      main: "#cb3366",
    },
  },
});

// RouteChangeHandler Component
const RouteChangeHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await getWebVersion();
        console.log("data>>>: ", response);
        console.log(
          "New version detected:",
          response.version,
          ">>>",
          packageJson.version,
          ">>>",
          semver.gt(response.version, packageJson.version)
        );

        // Check if the version is different
        if (
          response.version &&
          semver.gt(response.version, packageJson.version)
        ) {
          // Check if reload has already happened
          const lastReloadedVersion = sessionStorage.getItem(
            "lastReloadedVersion"
          );

          if (lastReloadedVersion !== response.version) {
            sessionStorage.setItem("lastReloadedVersion", response.version); // Update the version
            window.location.reload();
          }
        }
      } catch (error) {
        console.error("Error checking version:", error);
      }
    };

    checkVersion(); // Trigger version check on route change
  }, [location]);

  return null;
};

const App = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <ErrorBoundary>
            <ScreenLocker>
              <RouteChangeHandler />
              <AppRoutes />
              <ChatBot />
              <UniversalModals />
            </ScreenLocker>
          </ErrorBoundary>
        </BrowserRouter>
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default App;
